<template>
    <div class="unauthenticated row justify-content-center align-items-center">
        <!-- <div class="unauthenticated__filter"></div> -->
        <div v-if="!studentForm" class="col-12 d-flex flex-row-reverse p-0">
            <div class="unauthenticated__card card">
                <div class="unauthenticated__card-body  card-body">
                    <div class="unauthenticated__title mb-5">
                        <h3>Academic Dean's Office</h3>
                        <img class="unauthenticated__logo" src="../../assets/logo/kings-logo.jpg" alt="logo">
                    </div>
                    <div class="unauthenticated__description my-3">
                        <ul>
                            <li>If you are a <b>staff</b> and wish to access the <b>Card Services application</b>, you
                                must sign in to
                                the myKing's Staff Portal.</li>
                            <li>If you are a <b>student</b> and wish to check-in to our <b>Academic
                                    Counselling Check-In</b>,
                                please sign in using your Western credentials.</li>
                        </ul>
                    </div>
                    <span> <!--Added July 2024 - As requested by ITS & in agreement with ADO (KUC-1549) -->
                        <div class="alert alert-primary">
                            <i class="far fa-question"></i> If you have questions about the drop-in service please reivew the <a href="https://www.kings.uwo.ca/about-kings/facts-and-information/administrative-departments/academic-deans-office/">Academic Advising Webpage</a> <br />
                            Or email <a href="mailto:academic.counselling@kings.uwo.ca">academic.counselling@kings.uwo.ca</a>
                        </div>
                    </span>
                    <div class="unauthenticated__menu">
                        <a :href="staffLogin" class="btn btn-primary btn-block" @click="staffRedirect">
                            <span v-if="staff"><i class="fas fa-spinner fa-spin"></i></span>
                            <span v-else>Sign in as a Staff</span>
                        </a>
                        <button href="#" class="btn btn-primary btn-block" @click="studentRedirect">Sign in as a
                            Student</button>
                    </div>
                    <div>&nbsp;<br /><br /><br /><br /></div>
                </div>
            </div>
        </div>
        <div v-else class="col-12 d-flex flex-row-reverse p-0">
            <div class="unauthenticated__card card">
                <div class="unauthenticated__card-body card-body">
                    <div class="unauthenticated__title mb-5">
                        <h3>
                            Academic Counselling Check-In
                        </h3>
                        <img class="unauthenticated__logo" src="../../assets/logo/kings-logo.jpg" alt="logo">
                    </div>
                    <div v-if="dropInAlert.status" class="unauthenticated__dropin--message">
                        <div v-if="dropInAlert.type == 'success'" class="alert alert-success">
                            <i class="far fa-check"></i> {{ dropInAlert.message }}
                        </div>
                        <div v-if="dropInAlert.type == 'warning'" class="alert alert-warning">
                            <i class="fas fa-exclamation-circle"></i> {{ dropInAlert.message }}
                        </div>
                    </div>
                    <div class="unauthenticated__message">
                        <!-- -->
                        <div v-if="alert.type == 'success'" class="alert alert-success">
                            <i class="far fa-check"></i> {{ alert.message }}
                        </div>
                        <div v-else-if="alert.type == 'warning'" class="alert alert-warning">
                            <i class="far fa-exclamation-circle"></i> {{ alert.message }}
                        </div>
                        <div v-else-if="alert.type == 'error'" class="alert alert-danger">
                            <i class="fas fa-exclamation-triangle"></i> {{ alert.message }}
                        </div>
                    </div>
                    <div v-if="status.showWeekdayMessage == '1'" class="alert alert-primary" role="alert">
                        <p class="mb-0">{{ status.weekdayMessage }}</p>
                    </div>
                    <span v-if="getOpenStatus()">
                        <form>
                            <div class="form-group">
                                <label for="username"><i class="far fa-user"></i> Username</label>
                                <input v-model="username" type="text" class="form-control" id="username"
                                    placeholder="Enter Username" @keydown.enter="studentLogin">
                            </div>
                            <div class="form-group">
                                <label for="password"><i class="far fa-key"></i> Password</label>
                                <input v-model="password" type="password" class="form-control" id="password"
                                    placeholder="Enter Password" @keydown.enter="studentLogin">
                            </div>
                        </form>
                        <div class="unauthenticated__menu mt-4">
                            <button v-if="login" class="btn btn-primary btn-block" disabled type="button">
                                <span><i class="fas fa-spinner fa-spin"></i></span>
                            </button>
                            <button v-else class="btn btn-primary btn-block" @click="studentLogin" type="button">
                                <span>Sign In</span>
                            </button>
                            <button class="btn btn-primary btn-block" @click="generalRedirect"
                                type="button">Back</button>
                        </div>
                    </span>
                    <span v-else>
                        <div class="alert alert-warning" role="alert">
                            <h5 class="alert-heading">{{ getClosureType }}</h5>
                            <span v-if="status.closureType.type == 'virtual' && status.showCheckinMessage == '1'">
                                <hr>
                                <p class="mb-0">{{ status.checkinMessage }}</p>
                            </span>
                        </div>
                        <div class="unauthenticated__menu mt-4">
                            <button class="btn btn-primary btn-block" @click="generalRedirect"
                                type="button">Back</button>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'unauthenticated',
    props: {
        dropinstatus: {
            type: String
        }
    },
    data() {
        return {
            alert: {
                message: '',
                type: ''
            },
            dropInAlert: {
                message: '',
                status: false,
                type: ''
            },
            login: false,
            password: '',
            refreshCycle: '',
            staff: false,
            status: {
                checkinMessage: '',
                checkinMethodType: '',
                closed: 0,
                closureType: {
                    type: '',
                    typeMessage: '',
                    typeMessageShow: 0
                },
                showCheckinMessage: 0,
                showWeekdayMessage: 0,
                weekday: '',
                weekdayMessage: ''
            },
            student: false,
            studentForm: false,
            username: ''
        }
    },
    methods: {
        generalRedirect() {
            // Clear credentials
            this.password = '';
            this.username = '';
            this.login = false;
            this.studentForm = false;
        },
        getOpenStatus() {
            let bool = true;

            // Check manual shutdown
            if (this.status && this.status.closed == 1) {
                bool = false;
            }

            return bool;
        },
        getSystemSettings() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?statusVirtual`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Set system settings
                    that.status.checkinMessage = json.checkinMessage ? json.checkinMessage : that.status.checkinMessage;
                    that.status.checkinMethodType = json.checkinMethodType ? json.checkinMethodType : that.status.checkinMethodType;
                    that.status.closed = json.closed;
                    that.status.closureType = json.closureType ? json.closureType : that.status.closureType;
                    that.status.showCheckinMessage = json.showCheckinMessage;
                    that.status.showWeekdayMessage = json.showWeekdayMessage;
                    that.status.weekday = json.weekday ? json.weekday : that.status.weekday;
                    that.status.weekdayMessage = json.weekdayMessage ? json.weekdayMessage : that.status.weekdayMessage;
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        resolveDropInStatus() {
            let that = this;
            // Set the login to student
            this.studentForm = true;

            // Check if the student has been dequeud
            if (this.dropinstatus == "dequeued") {
                this.dropInAlert.type = 'success';
                this.dropInAlert.message = 'Your academic counselling has been successfully completed! If the academic counselling check-in is available and you require further assistance, please login.';
                this.dropInAlert.status = true;
            } else if (this.dropinstatus == "noappointments") {
                this.dropInAlert.type = 'warning';
                this.dropInAlert.message = 'Check-in capacity has been reached for today, but you will still be able to see a counsellor during this drop-in period. Please be patient and remain in the queue. Note that you will no longer be able to access the drop-in dashboard. You will receive an email informing you when the counsellor is ready to see you. Thank you for your patience as we proceed through this busy time.';
                this.dropInAlert.status = true;
            } else {
                // Reset alert
                this.dropInAlert.message = '';
                this.dropInAlert.status = false;
            }

            setTimeout(function () {
                // Redirect user session
                that.$router.push({
                    path: `/unauthenticated`
                });
            }, 10000);
        },
        staffRedirect() {
            this.staff = true;
        },
        studentLogin() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/api.pl`;
            const formData = new FormData();

            // Add form keypair values
            formData.append('mode', 'signIn');
            formData.append('username', this.username);
            formData.append('password', this.password);

            // Login details
            this.alert.message = '';
            this.alert.type = '';
            this.login = true;

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Successful login
                if (json.result.match(/OK/i)) {
                    // Valid credentials
                    that.alert.message = `Login successful! Please wait to be redirected.`;
                    that.alert.type = `success`;

                    // Store student session data
                    auth.create_session(json.data);

                    // Student redirect
                    that.$router.push({
                        path: '/student'
                    });
                } else if (json.result.match(/WARNING/i) && json.message.match(/NULL/gi)) {
                    // Missing credentials
                    that.alert.message = `Login unsuccessful. Either the username and/or password is missing.`;
                    that.alert.type = `warning`;
                    that.login = false;
                } else if (json.result.match(/WARNING/i) && json.message.match(/FAIL/gi)) {
                    // Invalid credentials
                    that.alert.message = `Login unsuccessful. Please enter a valid username and password.`;
                    that.alert.type = `warning`;
                    that.login = false;
                } else {
                    // Failed login
                    that.alert.message = `Login failed. An error has occurred. Please contact your system administrator.`;
                    that.alert.type = `error`;
                    that.login = false;
                }
            }).catch(function () {
                that.login = false;
            })
        },
        studentRedirect() {
            // Clear credentials
            this.password = '';
            this.username = '';
            this.login = false;
            this.studentForm = true;
        }
    },
    computed: {
        getClosureType() {
            if (this.status.closureType && this.status.closureType.type && this.status.closureType.type.match(/hours of operation/gi)) {
                return `Check-in is closed! We are sorry but our office is currently closed for appointments.`;
            } else if (this.status.closureType && this.status.closureType.type && this.status.closureType.type.match(/capacity/gi)) {
                return `Check-in capacity has been reached for today, but you will still be able to see a counsellor during this drop-in period. Please be patient and remain in the queue. Note that you will no longer be able to access the drop-in dashboard. You will receive an email informing you when the counsellor is ready to see you. Thank you for your patience as we proceed through this busy time. `;
            }

            return `Check-in is closed!`;
        },
        staffLogin() {
            // Generate redirect URL to Staff MyKing's
            return `https://${location.hostname}/cgi-bin/mkvn/app.pl?staff&redirect=1`;
        }
    },
    created() {
        const that = this;

        // Resolve status propr
        if (this.dropinstatus) {
            this.resolveDropInStatus();
        }

        // Retrieve database
        this.getSystemSettings();

        // Auto refresh
        this.refreshCycle = setInterval(function () {
            that.getSystemSettings();
        }, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshCycle);
    }
}
</script>

<style scoped>
.unauthenticated {
    background: url(../../assets/background/unauthenticated.png) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
}

.unauthenticated__card {
    height: 100vh !important;
    min-height: 100%;
    max-width: 575px;
    overflow: scroll;
    margin: 0;
    border: 0;
    border-radius: 0;
    padding-top: 175px;
    color: #004236;
    background: #fff;
    /* background-color: rgba(0, 0, 0, 0.85); */
    width: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.unauthenticated__card-body {
    background: transparent;
}

.unauthenticated__description {
    text-align: left;
}

.unauthenticated__filter {
    background: rgba(0, 0, 0, .5);
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
}

.unauthenticated__logo {
    width: 140px;
}

.unauthenticated__menu {
    text-align: center;
}

.unauthenticated__title {
    color: #004236;
    text-align: center;
}

@media (max-width: 768px) {
    .unauthenticated__card {
        padding-top: 55px;
    }
}
</style>